import { APIContext } from 'src/features/core/Intents/ApiContext/apiContextParser';
import { isNotEmpty } from 'src/utilities/hasValue';

// IF there is an api_context present in the workflow then use that to update.

interface IAPIContextResourceData {
  apiContexts: any[];
  answer: any;
  dispatch: any;
  apiResources: any;
  userIntents: any;
  currentIntent: any;
}

export const mkAPIContextResource = (data: IAPIContextResourceData) => {
  const { apiContexts, answer, dispatch, userIntents, currentIntent, apiResources } = data;
  if (isNotEmpty(apiContexts)) {
    const context = new APIContext({
      apiContexts,
      thisAnswer: answer,
      apiResources,
      dispatch,
      userIntents,
      currentIntent,
    });
    return context.apply();
  }
  return [];
};
